import { Dispatch, SetStateAction, useCallback } from 'react';
import { ValidationErrorState } from '../../../../types/validationErrorState';
import { TagsAutocomplete } from '../../TagsAutocomplete';
import { Box } from '@mui/material';

interface IProps {
  skills: string[];
  setSkills: Dispatch<SetStateAction<string[]>>;
  validationErrors: ValidationErrorState;
  skillsList: string[]
}

const UpdateSkills = ({setSkills, skills, validationErrors, skillsList}: IProps) => {
  const handleSkillsUpdate = useCallback((skills: string[]) => setSkills(skills), [setSkills]);
  return (
    <Box my={2}>
      <TagsAutocomplete
        list={skillsList}
        onChange={handleSkillsUpdate}
        value={skills}
        label={'Skills'}
        error={validationErrors?.skills || undefined}
      />
    </Box>
  )
};

export default UpdateSkills;